/*
 * Copyright 2025 ByOmakase, LLC (https://byomakase.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class FileUtil {
  static videoExtensions = ['.mp4'];
  static audioExtensions = ['.mp3', '.aac', '.ogg', '.opus', '.wav', '.flac'];

  static isM3u8File(sourceUrl: string) {
    return ['.m3u8'].some((ext) => sourceUrl.endsWith(ext));
  }

  static isVideoFile(sourceUrl: string) {
    return this.videoExtensions.some((ext) => sourceUrl.endsWith(ext));
  }

  static isAudioFile(sourceUrl: string) {
    return this.audioExtensions.some((ext) => sourceUrl.endsWith(ext));
  }
}
